import type { BadgeVariant } from '../../components/ui';
import type { KhoaDich } from '../../i18n';
import type { DenormTarget, DocumentType, ExtractionMode, FieldDataType, FieldPosition } from './types';

/**
 * Nhãn và tông của cấu hình loại chứng từ. Mang **khoá dịch**, không mang nhãn; màu là quyết định
 * trình bày nên ở đây, không ở `mock/` (tầng đó bị xoá khi có API thật).
 */

/** Loại chứng từ là **phân loại**: chỉ tông `neutral` để không đọc thành trạng thái. */
export const NHAN_LOAI: Record<DocumentType, KhoaDich> = {
  INVOICE: 'ocr.loai.INVOICE',
  RECEIPT: 'ocr.loai.RECEIPT',
  CONTRACT: 'ocr.loai.CONTRACT',
  STATEMENT: 'ocr.loai.STATEMENT',
  MINUTES: 'ocr.loai.MINUTES',
  WAREHOUSE_RECEIPT: 'ocr.loai.WAREHOUSE_RECEIPT',
  OTHERS: 'ocr.loai.OTHERS',
};

export const NHAN_KIEU_DU_LIEU: Record<FieldDataType, KhoaDich> = {
  TEXT: 'ocr.kieuDuLieu.TEXT',
  DATE: 'ocr.kieuDuLieu.DATE',
  NUMBER: 'ocr.kieuDuLieu.NUMBER',
  CURRENCY: 'ocr.kieuDuLieu.CURRENCY',
  BOOLEAN: 'ocr.kieuDuLieu.BOOLEAN',
  LIST: 'ocr.kieuDuLieu.LIST',
};

export const NHAN_VI_TRI: Record<FieldPosition, KhoaDich> = {
  HEADER: 'ocr.viTri.HEADER',
  BODY: 'ocr.viTri.BODY',
  FOOTER: 'ocr.viTri.FOOTER',
};

export const NHAN_COT_LOC: Record<DenormTarget, KhoaDich> = {
  INVOICE_NUMBER: 'ocr.cotLoc.INVOICE_NUMBER',
  ISSUE_DATE: 'ocr.cotLoc.ISSUE_DATE',
  SELLER_TAX_CODE: 'ocr.cotLoc.SELLER_TAX_CODE',
  SELLER_NAME: 'ocr.cotLoc.SELLER_NAME',
  TOTAL_AMOUNT: 'ocr.cotLoc.TOTAL_AMOUNT',
  VAT_AMOUNT: 'ocr.cotLoc.VAT_AMOUNT',
  GRAND_TOTAL: 'ocr.cotLoc.GRAND_TOTAL',
};

export const NHAN_CHE_DO: Record<ExtractionMode, KhoaDich> = {
  SINGLE_MODEL: 'ocr.cheDo.SINGLE_MODEL',
  OCR_THEN_MAP: 'ocr.cheDo.OCR_THEN_MAP',
};

/** Câu giải thích từng chế độ, hiện dưới ô chọn. */
export const MO_CHE_DO: Record<ExtractionMode, KhoaDich> = {
  SINGLE_MODEL: 'cauHinhOcr.cheDoMo.SINGLE_MODEL',
  OCR_THEN_MAP: 'cauHinhOcr.cheDoMo.OCR_THEN_MAP',
};

/** Bốn cờ xử lý của loại chứng từ, theo thứ tự hiện ở khối thông tin chung. */
export const CO_XU_LY = ['split_pdf_pages', 'enable_word_boxes', 'transform_by_prompt', 'model_self_map'] as const;
export type CoXuLy = (typeof CO_XU_LY)[number];
export const NHAN_CO: Record<CoXuLy, { nhan: KhoaDich; mo: KhoaDich }> = {
  split_pdf_pages: { nhan: 'cauHinhOcr.co.split_pdf_pages', mo: 'cauHinhOcr.co.split_pdf_pagesMo' },
  enable_word_boxes: { nhan: 'cauHinhOcr.co.enable_word_boxes', mo: 'cauHinhOcr.co.enable_word_boxesMo' },
  transform_by_prompt: { nhan: 'cauHinhOcr.co.transform_by_prompt', mo: 'cauHinhOcr.co.transform_by_promptMo' },
  model_self_map: { nhan: 'cauHinhOcr.co.model_self_map', mo: 'cauHinhOcr.co.model_self_mapMo' },
};

/** Loại chứng từ đang dùng / đã tắt: nhóm **trạng thái** (`success` đang phục vụ, `neutral` đã tắt). */
export const BADGE_DANG_DUNG: Record<'bat' | 'tat', { khoa: KhoaDich; variant: BadgeVariant }> = {
  bat: { khoa: 'cauHinhOcr.dangDung', variant: 'success' },
  tat: { khoa: 'cauHinhOcr.daTat', variant: 'neutral' },
};
